import { FsCore } from '../../types/fs-core'
import cleansedUserInputs from '../../utils/parse-calculator-inputs'

const calculatorsState = (s: FsCore.State) => s.calculators

export const getCalculator = (s: FsCore.State, key: string) => calculatorsState(s)[key]

export const getCalculatorInputs = (s: FsCore.State, key: string) =>
  cleansedUserInputs(getCalculator(s, key)?.inputs || {})
